import React from "react";
import { Form, Input, Button, Modal, DatePicker, Select } from "antd";
import axios from "axios";
import moment from "moment";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { get } from "lodash";

const FormItem = Form.Item;
const { Option } = Select;
const dateFormat = "YYYY-MM-DD";

class EventFormInit extends React.Component {
  state = {
    event: {},
  };

  componentDidMount() {
    let token = localStorage.getItem("token");
    axios.defaults.xsrfCookieName = "csrftoken";
    axios.defaults.xsrfHeaderName = "X_CSRFTOKEN";
    axios.defaults.headers = {
      "Content-Type": "application/json",
      "Accept-Language": localStorage.getItem("language"),
      Authorization: `Token ${token}`,
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.handleFormSubmit(
          values,
          e,
          this.props.requestType,
          this.props.data.id
        );
        console.log("Received values of form: ", values);
      }
    });
  };

  handleFormSubmit = (values, event, requestType, eventID) => {
    let filtered_assigned_to = this.props.users.filter((item) => {
      if (values.assigned_to && values.assigned_to.includes(item.id))
        return true;
    });
    let filtered_tags = this.props.tags.filter((item) => {
      if (values.tags && values.tags.includes(item.slug)) return true;
    });
    let filtered_contacts = this.props.contacts.filter((item) => {
      if (values.contacts && values.contacts.includes(item.id)) return true;
    });

    let start_date;
    if (values.start_date == undefined) start_date = null;
    else start_date = values.start_date.format(dateFormat);

    let end_date;
    if (values.end_date == undefined) end_date = null;
    else end_date = values.end_date.format(dateFormat);

    let lead;
    if (values.lead == undefined) lead = null;
    else lead = values.lead;

    const postObj = {
      name: values.name,
      status: values.status,
      event_type: values.event_type,
      description: values.description,
      start_date: start_date,
      end_date: end_date,
      assigned_to: filtered_assigned_to,
      created_by: values.created_by,
      // created_on: event.target.elements.created_on.value,
      tags: filtered_tags,
      contacts: filtered_contacts,
      lead: lead,
    };

    if (requestType === "post") {
      axios
        .post(process.env.REACT_APP_AXIOS_URL + "/api/events/create/", postObj)
        .then((res) => {
          console.log(res.status);
          if (res.status === 201) {
            this.props.handleState("modalVisible", false);
            this.props.fetch();
          }
        });
    } else if (requestType === "put") {
      axios
        .put(
          process.env.REACT_APP_AXIOS_URL + `/api/events/${eventID}/update/`,
          postObj
        )
        .then((res) => {
          if (res.status === 200) {
            this.props.handleState("modalVisible", false);
            this.props.fetch();
          }
        });
    }
    // if (success)
    //     this.props.handleState('modalVisible', false);
  };

  handleDelete = (event) => {
    event.preventDefault();
    const eventID = this.props.match.params.eventID;
    axios
      .delete(
        process.env.REACT_APP_AXIOS_URL + `/api/events/${eventID}/delete/`
      )
      .then((res) => {
        if (res.status === 204 || res.status === 200) {
          this.props.fetch();
        }
      });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { onCancel, requestType, lead_list, visible, btnText, titleText, t } =
      this.props;
    const leads = get(lead_list, "results", []);

    let tags_filtered,
      users_filtered,
      contacts_filtered,
      created_by,
      lead = [];
    if (requestType === "put") {
      tags_filtered = this.props.data.tags.map((item) => {
        return item.slug;
      });
      users_filtered = this.props.data.assigned_to.map((item) => {
        return item.id;
      });
      contacts_filtered = this.props.data.contacts.map((item) => {
        return item.id;
      });
    } else if (requestType === "get") {
      tags_filtered = this.props.data.tags.map((item) => {
        return item.name + ", ";
      });
      users_filtered = this.props.data.assigned_to.map((item) => {
        return item.first_name + " " + item.last_name + ", ";
      });
      contacts_filtered = this.props.data.contacts.map((item) => {
        return item.first_name + " " + item.last_name + ", ";
      });
      created_by = this.props.users.filter((item) => {
        if (item.id == this.props.data.created_by) return true;
      });
      lead = leads.filter((item) => {
        if (item.id == this.props.data.lead) return true;
      });
    }

    // let event_status_list;
    // if (this.props.event_status_list == null)
    //     event_status_list = this.props.data.event_status_list;
    // else
    //     event_status_list = this.props.event_status_list;

    // let event_type_list;
    // if (this.props.event_type_list == null)
    //     event_type_list = this.props.data.event_type_list;
    // else
    //     event_type_list = this.props.event_type_list;

    let created_on;
    if (this.props.data.created_on)
      created_on = moment(this.props.data.created_on, dateFormat);
    else created_on = moment(new Date(), dateFormat);

    let start_date;
    if (this.props.data.start_date)
      start_date = moment(this.props.data.start_date, dateFormat);
    else start_date = null;

    let end_date;
    if (this.props.data.end_date)
      end_date = moment(this.props.data.end_date, dateFormat);
    else end_date = null;

    let admins;
    admins = this.props.users.filter((item) => item.role === "ADMIN");

    if (requestType === "get" && start_date != null)
      start_date = start_date.format(dateFormat);
    if (requestType === "get" && end_date != null)
      end_date = end_date.format(dateFormat);

    let footer = [];
    if (this.props.requestType === "post" || this.props.requestType === "put") {
      footer = [
        <Button key="back" onClick={onCancel}>
          {t("general.cancel", "Cancel")}
        </Button>,
        <Button key="submit" type="primary" onClick={this.handleSubmit}>
          {btnText}
        </Button>,
      ];
    } else {
      footer = [
        <Button key="back" onClick={onCancel}>
          {t("general.cancel", "Cancel")}
        </Button>,
      ];
    }
    return (
      <Modal
        visible={visible}
        title={titleText}
        onCancel={onCancel}
        footer={footer}
      >
        <Form
          layout="vertical"
          id="event-form"
          hideRequiredMark
          onSubmit={this.handleSubmit}
        >
          <Form.Item label={t("events.event_form.name", "Name")}>
            {requestType === "get" ? (
              <span className="ant-form-text">{this.props.data.name}</span>
            ) : (
              getFieldDecorator("name", {
                initialValue: this.props.data.name,
                rules: [
                  {
                    required: true,
                    message: t(
                      "events.event_form.name_required",
                      "Please input the name of event!"
                    ),
                  },
                ],
              })(<Input name="name" type="text" />)
            )}
          </Form.Item>
          <Form.Item label={t("events.event_form.description", "Description")}>
            {requestType === "get" ? (
              <span className="ant-form-text">
                {this.props.data.description}
              </span>
            ) : (
              getFieldDecorator("description", {
                initialValue: this.props.data.description,
                // rules: [{ required: true, message: 'Please input the title of event!' }],
              })(<Input type="textarea" name="description" />)
            )}
          </Form.Item>
          <FormItem label={t("events.event_form.start_date", "Start date")}>
            {requestType === "get" ? (
              <span className="ant-form-text">{start_date}</span>
            ) : (
              getFieldDecorator("start_date", {
                initialValue: start_date,
                rules: [
                  {
                    type: "object",
                    // required: true, message: 'Description is required!'
                  },
                ],
              })(<DatePicker name="start_date" format={dateFormat} />)
            )}
          </FormItem>
          <FormItem label={t("events.event_form.end_date", "End date")}>
            {requestType === "get" ? (
              <span className="ant-form-text">{end_date}</span>
            ) : (
              getFieldDecorator("end_date", {
                initialValue: end_date,
                rules: [
                  {
                    type: "object",
                    // required: true, message: 'Description is required!'
                  },
                ],
              })(<DatePicker name="end_date" format={dateFormat} />)
            )}
          </FormItem>
          <FormItem label={t("events.event_form.tags", "Tags")}>
            {requestType === "get" ? (
              <span className="ant-form-text">{tags_filtered}</span>
            ) : (
              getFieldDecorator("tags", {
                initialValue: tags_filtered,
                rules: [
                  {
                    type: "array",
                  },
                ],
              })(
                <Select
                  mode="multiple"
                  name="tags"
                  placeholder={t(
                    "events.event_form.tags_select",
                    "Select tags"
                  )}
                >
                  {this.props.tags.map((item) => (
                    <Option key={item.slug} value={item.slug}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              )
            )}
          </FormItem>
          <FormItem label={t("events.event_form.contacts", "Contacts")}>
            {requestType === "get" ? (
              <span className="ant-form-text">{contacts_filtered}</span>
            ) : (
              getFieldDecorator("contacts", {
                initialValue: contacts_filtered,
                rules: [
                  {
                    type: "array",
                  },
                ],
              })(
                <Select
                  mode="multiple"
                  name="contacts"
                  placeholder={t(
                    "events.event_form.contacts_select",
                    "Select contacts"
                  )}
                >
                  {this.props.contacts.map((item) => (
                    <Option key={item.id} value={item.id}>
                      {item.first_name} {item.last_name}
                    </Option>
                  ))}
                </Select>
              )
            )}
          </FormItem>
          <FormItem label={t("events.event_form.assgined_to", "Assigned to")}>
            {requestType === "get" ? (
              <span className="ant-form-text">{users_filtered}</span>
            ) : (
              getFieldDecorator("assigned_to", {
                initialValue: users_filtered,
                rules: [
                  {
                    type: "array",
                    // required: true, message: 'Phone number is required!'
                  },
                ],
              })(
                <Select
                  mode="multiple"
                  name="assigned_to"
                  placeholder={t(
                    "events.event_form.assigned_to_select",
                    "Select users"
                  )}
                >
                  {admins.map((item) => (
                    <Option key={item.id} value={item.id}>
                      {item.first_name} {item.last_name}
                    </Option>
                  ))}
                </Select>
                // <Input name="assigned_to" />
              )
            )}
          </FormItem>
          {/* <FormItem label={t('events.event_form.status', "Status of event")}>
                        {
                            requestType === 'get' ?
                                <span className="ant-form-text">{this.props.data.status}</span> :
                                getFieldDecorator('status', {
                                    initialValue: this.props.data.status,
                                    rules: [{
                                        // required: true, message: 'Phone number is required!'
                                    }],
                                })(
                                    <Select name='status' placeholder={t('events.event_form.status_select', "Select status of event")}>
                                        {event_status_list.map(item => (
                                            <Option key={item[0]} value={item[0]}>{item[1]}</Option>
                                        ))}
                                    </Select>
                                )
                        }
                    </FormItem> */}
          {/* <FormItem label={t('events.event_form.type', "Event type")}>
                        {
                            requestType === 'get' ?
                                <span className="ant-form-text">{this.props.data.event_type}</span> :
                                getFieldDecorator('event_type', {
                                    initialValue: this.props.data.event_type,
                                    rules: [{
                                        // required: true, message: 'Phone number is required!'
                                    }],
                                })(
                                    <Select name='event_type' placeholder={t('events.event_form.type_select', "Select type of event")}>
                                        {event_type_list.map(item => (
                                            <Option key={item[0]} value={item[0]}>{item[1]}</Option>
                                        ))}
                                    </Select>
                                )
                        }
                    </FormItem> */}
          <FormItem label={t("events.event_form.created_by", "Created by")}>
            {requestType === "get" ? (
              <span className="ant-form-text">
                {created_by[0]
                  ? created_by[0].first_name + created_by[0].last_name
                  : ""}
              </span>
            ) : (
              getFieldDecorator("created_by", {
                initialValue: this.props.data.created_by,
                rules: [
                  {
                    type: "number",
                    // required: true, message: 'Phone number is required!'
                  },
                ],
              })(
                <Select
                  name="created_by"
                  placeholder={t(
                    "events.event_form.created_by_select",
                    "Select user"
                  )}
                >
                  {admins.map((item) => (
                    <Option key={item.id} value={item.id}>
                      {item.first_name} {item.last_name}
                    </Option>
                  ))}
                </Select>
              )
            )}
          </FormItem>
          <FormItem label={t("tasks.task_form.lead", "Lead")}>
            {requestType === "get" ? (
              <span className="ant-form-text">
                {lead && lead[0] ? lead[0].name : null}
              </span>
            ) : (
              getFieldDecorator("lead", {
                initialValue: this.props.data.lead,
                rules: [
                  {
                    type: "number",
                    // required: true, message: 'Phone number is required!'
                  },
                ],
              })(
                <Select
                  name="lead"
                  placeholder={t("tasks.task_form.lead_select", "Select lead")}
                  allowClear
                >
                  {leads.map((item) => (
                    <Option key={item.id} value={item.id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              )
            )}
          </FormItem>
        </Form>
      </Modal>
    );
  }
}

const EventForm = Form.create()(withTranslation()(EventFormInit));
<EventForm wrappedComponentRef={(form) => (this.form = form)} />;
this.form;
export default withRouter(EventForm);



// WEBPACK FOOTER //
// ./src/containers/Events/EventForm.js